
import currencies from '../../api/currencies'

export default {
  state: {
    currencies:[]
  },
  namespaced: true,
  mutations: {
    async saveCurrencies(state, currencies) {
      state.currencies = currencies
    }
  },
  actions: {
    async saveCurrencyStore ({ commit }) {
      commit('saveCurrencies', await currencies.currencies())
    },

  },
  getters: {
    getCurrencies: state => state.currencies,
  },

}
